import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './Component/APIServices/store';
import AutoLogout from './Component/sharedFiles/autoLogout';
import { ToastContainer } from 'react-toastify';
import "bootstrap/dist/css/bootstrap.min.css";
import AppRoutes from './AppRoutes';

function App() {
  const [databaseName, setDatabaseName] = useState(null);

  return (
    <Provider store={store}>
      <Router basename="/">
        <AutoLogout>
          <ToastContainer
            position="top-center"
            toastOptions={{
              style: {
                fontSize: '16px',
                padding: '16px',
                width: '400px',
                borderRadius: '8px',
              },
            }}
          />
          <AppRoutes />
        </AutoLogout>
      </Router>
    </Provider>
  );
}

export default App;


// import { useState } from 'react';
// // import './App.css';
// import React from 'react';
// import LoginPage from './Component/LoginPage/LoginPage';
// import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
// import Dashboard from './Component/Dashboard/dashboard';
// // import store from './Component/ReduxStore/store';
// import store from './Component/APIServices/store';
// import { Provider } from 'react-redux';
// import Checkout from './Component/checkout/Checkout';
// // import ItemPageModular from './Component/itemPage copy/ItemPagemain';
// import AutoLogout from './Component/sharedFiles/autoLogout';
// import StagesTable from './testTable/stagesTable';
// import ReportStatement from './Component/leadgerStatement/ReportsStatement';
// import OrderHistoryMain from './Component/Orderhistory/orderHistoryMain';
// import "bootstrap/dist/css/bootstrap.min.css";
// import InvoiceReport from './Component/GenerateReport/generateReport';
// import OrderHistoryMain1 from './Component/Orderhistory/orderHistoryMain1';
// import ItemPage from './Component/itemPage/ItemPage';
// import { ToastContainer } from 'react-toastify';
// import ItemPageWrapper from './Component/itemPage/itempageWrapper';
// function App() {
//   const [databaseName, setDatabaseName] = useState(null);
//   const location = useLocation();
//   return (
//     <>
//       {/* provide the database name */}
//       <Provider store={store}>
//         <Router basename="/">
//           <ToastContainer
//             position="top-center"
//             toastOptions={{
//               style: {
//                 fontSize: '16px',
//                 padding: '16px',
//                 width: '400px',
//                 borderRadius: '8px',
//               },
//             }}
//           />
//           <AutoLogout>
//             <Routes>
//               <Route path="/" element={<LoginPage />} />
//               <Route path="/DashBoard" element={<Dashboard />} />
//               {/* <Route path="/GetGroupItem" element={<ItemPage/>} /> */}
//               {/* <Route path="/ItemPageModular" element={<ItemPageModular />} /> */}
//               <Route path="/Checkout" element={<Checkout />} />
//               <Route path="/orderHistory" element={<OrderHistoryMain1 />} />
//               <Route path="/ReportTemplate" element={<InvoiceReport />} />
//               <Route path="/stagesTable" element={<StagesTable />} />
//               <Route path="/Reports" element={<ReportStatement />} />
//               {/* <Route path="/ItemPage" element={<ItemPage />} /> */}
//               <Route path="/ItemPage" element={<ItemPageWrapper key={location.pathname} />} />
//             </Routes>
//           </AutoLogout>
//         </Router>
//       </Provider>
//     </>
//   );
// }
// document.addEventListener('DOMContentLoaded', () => {
//   const scrollbars = document.querySelectorAll('::-webkit-scrollbar');
//   scrollbars.forEach(scrollbar => {
//     scrollbar.addEventListener('mouseenter', () => {
//       scrollbar.classList.add('hovered');
//     });
//     scrollbar.addEventListener('mouseleave', () => {
//       scrollbar.classList.remove('hovered');
//     });
//   });
// });
// export default App;
